export default "__VITE_ASSET__DLJQLYoc__"